<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-layout justify-center align-center class="auth-layout">
            <v-flex text-center class="auth-layout__column">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="auth-form"
                    @submit.prevent
                >
                    <div class="title mb-2"> Восстановление пароля </div>
                    <div class="subtitle">
                        Введите электронную почту от личного кабинета. <br>
                        Мы вышлем на неё ссылку для сброса пароля
                    </div>
                    <v-text-field
                        v-model="email"
                        :rules="rules"
                        placeholder="Электронная почта"
                        class="grey-input ma-0"
                        required
                        :error="error"
                        :error-messages="errorMessage"
                        @input="deleteError"
                    ></v-text-field>
                    <v-btn
                        :disabled="!valid"
                        class="auth-btn"
                        @click="validate"
                        :class="{'mt-8': error}"
                        type="submit"
                    >
                        Восстановить пароль
                    </v-btn>
                </v-form>
            </v-flex>
            <v-flex text-center class="auth-layout__column">
                <v-img
                    :src="require('@/assets/images/error.svg')"
                    class="d-inline-flex"
                ></v-img>
            </v-flex>
            <div class="auth-layout__title title"> Восстановление пароля </div>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'ResetPassword',
    data() {
        return {
            email: null,
            password: null,
            valid: true,
            rules: [value => !!value || 'Обязательное поле'],
            error: null,
            errorMessage: null,
        };
    },
    methods: {
        resetPassword() {
            this.$http.post('/users/hotel-admin/reset-password/', {
                email: this.email,
            })
                .then(() => {
                    this.$router.push({ name: "login" });
                })
                .catch((error) => {
                    console.log(error);
                    this.errorMessage = "Адрес не найден";
                    this.error = true;
                });
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.valid) {
                this.resetPassword();
            } else {
                this.errorMessage = "Обязательное поле";
            }
        },
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>